const regExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const isValidEmail = (email: string | undefined) => regExp.test(email || "")

const telRegExp = /^(\+|00)?[1-9][0-9 \-().]{6,32}$/
const isValidTel = (tel: string) => telRegExp.test(tel)

export { isValidEmail, isValidTel }
